export const FETCH_USER_INFO = "FETCH_USER_INFO";
export const FETCH_USER_INFO_SUCCESS = "FETCH_USER_INFO_SUCCESS";
export const FETCH_SEARCH_RECORDS = "FETCH_SEARCH_RECORDS";
export const FETCH_SEARCH_RECORDS_SUCCESS = "FETCH_SEARCH_RECORDS_SUCCESS";
export const FETCH_SEARCH_RECORDS_RESET = "FETCH_SEARCH_RECORDS_RESET";
export const FETCH_CONTRACTOR_INFO = "FETCH_CONTRACTOR_INFO";
export const FETCH_CONTRACTOR_INFO_SUCCESS = "FETCH_CONTRACTOR_INFO_SUCCESS";
export const UPDATE_CONTRACTOR_SELECTION = "UPDATE_CONTRACTOR_SELECTION";
export const UPDATE_RECEIVED_DATE = "UPDATE_RECEIVED_DATE";
export const UPDATE_WAIVER_RECEIVED = "UPDATE_WAIVER_RECEIVED";
export const FETCH_WARRANTY_DETAILS = "FETCH_WARRANTY_DETAILS";
export const FETCH_WARRANTY_DETAILS_SUCCESS = "FETCH_WARRANTY_DETAILS_SUCCESS";
export const UPDATE_FORM_SUBMITTED_STATUS = "UPDATE_FORM_SUBMITTED_STATUS";
export const DELETE_SUBMITTED_WARRANTY = "DELETE_SUBMITTED_WARRANTY";
export const DELETE_SUBMITTED_SHOPPING_CART = "DELETE_SUBMITTED_SHOPPING_CART";
export const INVALID_WARRANTY_ENTRY = "INVALID_WARRANTY_ENTRY";
